import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
var supportedLanguages = [
    'en-us',
    'en-gb',
    'en-ca',
    'en-au',
    'zh-cn',
    'zh-tw',
    'zh-hk',
    'es-es',
    'es-mx',
    'es-co',
    'es-ar',
    'hi',
    'ar-sa',
    'ar-eg',
    'ar-ae',
    'ar-ma',
    'pt-br',
    'pt-pt',
    'bn',
    'bn-in',
    'ru',
    'ja',
    'ko',
    'pa-in',
    'pa-pk',
    'jv',
    'te',
    'ta',
    'ta-lk',
    'ur-pk',
    'ur-in',
    'vi',
    'ms-my',
    'ms-id',
    'ha-ng',
    //'ha-ne',
    /*'am',*/
    'my',
    'th',
    'ne',
    'km',
    'fr-fr',
    'fr-ca',
    'de-de',
    'de-at',
    'de-ch',
    'it-it',
    'it-ch',
    'nl-nl',
    'nl-be',
    'pl',
    'tr',
    'uk',
    'el',
    'sv',
];
var determineClosestLanguage = function (languageCode) {
    if (languageCode === 'en') {
        return 'en-us';
    }
    else if (languageCode === 'es') {
        return 'es-es';
    }
    else if (languageCode === 'zh') {
        return 'zh-cn';
    }
    else if (languageCode === 'ar') {
        return 'ar-sa';
    }
    else if (languageCode === 'pt') {
        return 'pt-br';
    }
    else if (languageCode === 'bn') {
        return 'bn-in';
    }
    else if (languageCode === 'pa') {
        return 'pa-in';
    }
    else if (languageCode === 'ta') {
        return 'ta-lk';
    }
    else if (languageCode === 'it') {
        return 'it-it';
    }
    else if (languageCode === 'nl') {
        return 'nl-nl';
    }
    else if (languageCode === 'pl') {
        return 'pl';
    }
    else if (languageCode === 'tr') {
        return 'tr';
    }
    else if (languageCode === 'uk') {
        return 'uk';
    }
    else if (languageCode === 'el') {
        return 'el';
    }
    else if (languageCode === 'sv') {
        return 'sv';
    }
    // Step 1: Check if the language is supported directly
    if (supportedLanguages.includes(languageCode)) {
        return languageCode.toLowerCase();
    }
    // Step 2: Try the base language (e.g., "en" from "en-us")
    var baseLanguage = languageCode.split('-')[0];
    var fallback = supportedLanguages.find(function (lang) { return lang.startsWith(baseLanguage); });
    if (fallback) {
        return fallback.toLowerCase();
    }
    // Step 3: Default to a universal fallback
    return 'en-us'; // Change this as per your app's default language
};
var languageCacheBreaker = '2024-11-11';
i18n
    .use(Backend) // Load translations from /public/locales
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    backend: {
        loadPath: '/dist/assets/locales/{{lng}}.json?v=' + languageCacheBreaker, // Path to the language files
    },
    supportedLngs: supportedLanguages,
    lowerCaseLng: true,
    lng: determineClosestLanguage(navigator.language || 'en-us'), // Use browser language or default
    fallbackLng: function (language) { return determineClosestLanguage(language); },
    interpolation: {
        escapeValue: false, // React already escapes by default
    },
});
export default i18n;
